import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { Rating } from '@app/_models/feedback';

@Component({
  selector: 'RatingSticker',
  templateUrl: './ratingSticker.component.html',
  styleUrls: ['./ratingSticker.component.scss']
})
export class RatingSticker implements AfterViewInit {
  @Input() ratings: Array<Rating>;
  constructor(
  ) { }

  ngAfterViewInit() {
  }

}
